import { useLayoutEffect } from "react";
import { CompanyDesc } from "../components/companyinfo/CompanyDesc";
import { CompanyMap } from "../components/companyinfo/CompanyMap";
import { ProductLineUp } from "../components/companyinfo/ProductLineUp";
import styles from "./CompanyInfoScreen.module.css";
import { Helmet } from "react-helmet-async";

/**
 * @author yjkim
 * @date 2022-10-04 17:50:23
 * @remark 한국공간정보통신 회사소개 페이지 스크린
 * @returns <IntroduceScreen/>
 */

function CompanyInfoScreen() {
    return (
        <>
            <Helmet>
                <title>회사 소개 - 모두의지도</title>
                <meta name="description" content="모두의지도 운영사 소개" />
            </Helmet>

            <div>
                <div className={styles.top_div}>
                    <ProductLineUp />
                    <CompanyDesc />
                </div>
                <CompanyMap />
            </div>
        </>
    );
}

export default CompanyInfoScreen;
